import React, { useEffect, useState } from "react";
import { blogImageUrl } from "./blogUtils";

/**
 * Blog thumbnail/banner with a branded fallback.
 *
 * Blog images live on S3 and individual objects can be missing or private, so a
 * plain <img> leaves a broken-image icon in the middle of the layout. On error
 * (or when the API sends no filename at all) we render a monogram tile instead.
 */
const BlogImage = ({ src, alt = "", className = "", eager = false }) => {
  const resolved = blogImageUrl(src);
  const [failed, setFailed] = useState(!resolved);
  // Keyed by URL rather than a boolean, so a recycled instance never shows the
  // previous image's loaded state and no reset effect can race the load event.
  const [loadedSrc, setLoadedSrc] = useState("");
  const loaded = loadedSrc === resolved;

  // A new card can reuse this component instance when the list re-renders.
  useEffect(() => {
    setFailed(!resolved);
  }, [resolved]);

  if (failed) {
    return (
      <div className={`blog-img-fallback ${className}`.trim()} role="img" aria-label={alt}>
        <span className="blog-img-fallback-mark">SU</span>
        <span className="blog-img-fallback-text">Salary Uncle</span>
      </div>
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      className={`${className} ${loaded ? "" : "blog-img-loading"}`.trim()}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      onLoad={() => setLoadedSrc(resolved)}
      onError={() => setFailed(true)}
    />
  );
};

export default BlogImage;
